import { RequestServiceImageProps } from '../types';

export const RequestServiceImage = ({
  imageSrc,
  imageAlt,
  classname
}: RequestServiceImageProps) => {
  return (
    <figure className={classname}>
      <img src={imageSrc} alt={imageAlt} />
    </figure>
  );
};
